<template>
  <div class="collection-header critical-component-clear">
    <category-linklist v-if="section.showLinklist" :links="liquid.linklist" />

    <div
      v-if="section.showTitle || section.showDescription"
      class="container grid"
    >
      <div class="col xs-span m5 l10">
        <component
          :is="section.headerElementType"
          v-if="section.showTitle"
          class="collection-header__title text-mobile-headlines-h3 text-desktop-headlines-h3"
          v-html="liquid.title"
        />

        <div
          v-if="section.showDescription"
          class="collection-header__description-wrapper"
        >
          <read-more-less
            class="rich-text__content collection-header__description rte"
            :characters="readMoreLess.characters"
            :content="liquid.description"
            :enable-truncation="readMoreLess.enableTruncation"
            :lines="readMoreLess.lines"
            :mobile-only="readMoreLess.mobileOnly"
            :section-id="liquid.sectionId"
            :rte-content="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Collection header (collection-header)
 * -----------------------------------------------------------------------------
 * Collection Header Section.
 *
 * @param {String} liquid.description - Collection description.
 * @param {Array} liquid.linklist - Navigation linklist.
 *  for truncation.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.title - Collection title.
 * @param {Object} readMoreLess - Read more/less settings.
 * @param {String} section.headerElementType - Element type for title.
 * @param {Boolean} section.showDescription - Show collection description.
 * @param {Boolean} section.showLinklist - Show linklist.
 * @param {Boolean} section.showTitle - Show collection title.
 *
 */
import CategoryLinklist from '~async/category-linklist/category-linklist';
import ReadMoreLess from '~async/read-more-less/read-more-less';

export default {
  name: 'CollectionHeader',

  components: {
    CategoryLinklist,
    ReadMoreLess,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        linklist: [],
        sectionId: '',
        title: '',
      }),
    },
    readMoreLess: {
      type: Object,
      default: () => ({
        characters: 0,
        enableTruncation: true,
        lines: 2,
        mobileOnly: true,
      }),
    },
    section: {
      type: Object,
      default: () => ({
        headerElementType: 'h1',
        showDescription: true,
        showLinklist: true,
        showTitle: true,
      }),
    },
  },

  data() {
    return {
      elements: {},
    };
  },
};
</script>

<style lang="scss">
@import './collection-header';
</style>
